import React from "react";
import { ColorValue, View, ViewStyle } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { useUnistyles } from "react-native-unistyles";

interface GradientBorderWrapperProps {
  children: React.ReactNode;
  colors?: string[];
  borderWidth?: number;
  borderRadius?: number;
  style?: ViewStyle;
}

export function GradientBorderWrapper({
  children,
  colors,
  borderWidth = 1,
  borderRadius = 8,
  style,
}: GradientBorderWrapperProps) {
  const { theme } = useUnistyles();

  // Default gradient colors if not provided
  const gradientColors =
    colors ||
    ([theme.colors.cyan[500], theme.colors.blue[500], theme.colors.blue[500], theme.colors.red[500]] as const);

  return (
    <LinearGradient
      colors={gradientColors as [ColorValue, ColorValue, ...ColorValue[]]}
      start={{ x: 0.5, y: -0.5 }}
      end={{ x: 0.6, y: 1.5 }}
      style={[
        {
          padding: borderWidth,
          borderRadius: borderRadius,
          borderCurve: "continuous",
        },
        style,
      ]}
    >
      <View
        style={{
          backgroundColor: theme.colors.interactive.buttons.default_background,
          borderRadius: borderRadius - borderWidth,
          borderCurve: "continuous",
          overflow: "hidden",
        }}
      >
        {children}
      </View>
    </LinearGradient>
  );
}
